import React from "react";
import { Formik, FieldArray } from "formik";
import { onBoardingScreenValidationSchema } from "../../../../utils/validationSchemas/MasterDataSchema";
import CustomImageUpload from "../../../components/Forms/CustomInputs/CustomImageUpload";
import CustomTextbox from "../../../components/Forms/CustomInputs/CustomTextbox";

const OnBoardingForm = ({ initialValues, handleFormSubmit }) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={onBoardingScreenValidationSchema}
      onSubmit={(values, ...rest) =>
        handleFormSubmit(values, ...rest, "onboarding")
      }
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched,
      }) => (
        <form onSubmit={handleSubmit}>
          <FieldArray name="onboarding_screen">
            {({ push, remove }) => (
              <div>
                {values.onboarding_screen.map((_, index) => (
                  <div
                    className="mb-5 pb-3"
                    style={{
                      borderBottom: `${
                        index < values?.onboarding_screen?.length - 1
                          ? "1px"
                          : "0px"
                      } solid`,
                    }}
                    key={index}
                  >
                    <div className="row">
                      <CustomImageUpload
                        fieldName={`onboarding_screen[${index}].image`}
                        value={values?.onboarding_screen?.[index]?.image}
                        error={
                          touched?.onboarding_screen?.[index]?.image
                            ? errors?.onboarding_screen?.[index]?.image
                            : ""
                        }
                        label={"Upload mage (9:16 / e.g. 450px X 800px)"}
                        imageRatio="9_16"
                        classes={"col-md-12"}
                        handleBlur={handleBlur}
                        inputType={"text"}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                      />

                      <CustomTextbox
                        fieldName={`onboarding_screen[${index}].title`}
                        value={values?.onboarding_screen?.[index]?.title}
                        // error={errors?.onboarding_screen?.[index]?.title}
                        error={
                          touched?.onboarding_screen?.[index]?.title
                            ? errors?.onboarding_screen?.[index]?.title
                            : ""
                        }
                        label={"Title"}
                        classes={"col-md-12"}
                        handleBlur={handleBlur}
                        inputType={"text"}
                        handleChange={handleChange}
                      />
                      <CustomTextbox
                        fieldName={`onboarding_screen[${index}].subtitle`}
                        value={values?.onboarding_screen?.[index]?.subtitle}
                        // error={errors?.onboarding_screen?.[index]?.subtitle}
                        error={
                          touched?.onboarding_screen?.[index]?.subtitle
                            ? errors?.onboarding_screen?.[index]?.subtitle
                            : ""
                        }
                        label={"SubTitle"}
                        classes={"col-md-12"}
                        handleBlur={handleBlur}
                        inputType={"text"}
                        handleChange={handleChange}
                      />
                      <CustomTextbox
                        fieldName={`onboarding_screen[${index}].button_text`}
                        value={values?.onboarding_screen?.[index]?.button_text}
                        // error={errors?.onboarding_screen?.[index]?.button_text}
                        error={
                          touched?.onboarding_screen?.[index]?.button_text
                            ? errors?.onboarding_screen?.[index]?.button_text
                            : ""
                        }
                        label={"Button Text"}
                        classes={"col-md-12"}
                        handleBlur={handleBlur}
                        inputType={"text"}
                        handleChange={handleChange}
                      />
                      <div className="col-md-12 my-2">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`onboarding_screen_${index}_load_fullscreen`}
                            name={`onboarding_screen[${index}].load_fullscreen`}
                            checked={
                              !!values?.onboarding_screen?.[index]
                                ?.load_fullscreen
                            }
                            onChange={(e) =>
                              setFieldValue(
                                `onboarding_screen[${index}].load_fullscreen`,
                                e.target.checked
                              )
                            }
                          />
                          <label
                            htmlFor={`onboarding_screen_${index}_load_fullscreen`}
                            className="form-check-label"
                          >
                            Load Image in Full Screen (Button UI will be changed
                            respectively)
                          </label>
                        </div>
                      </div>
                      {/* CONDITIONAL COLOR PICKERS */}
                      {values?.onboarding_screen[index]?.load_fullscreen && (
                        <>
                          <CustomTextbox
                            fieldName={`onboarding_screen[${index}].title_text_color`}
                            value={
                              values?.onboarding_screen[index]
                                ?.title_text_color || "#000000"
                            }
                            // error={
                            //   screenTouched?.title_text_color
                            //     ? screenErrors?.title_text_color
                            //     : ""
                            // }
                            label={"Title Text Color"}
                            classes={"col-md-6"}
                            handleBlur={handleBlur}
                            inputType={"color"}
                            handleChange={handleChange}
                          />

                          <CustomTextbox
                            fieldName={`onboarding_screen[${index}].description_text_color`}
                            value={
                              values?.onboarding_screen[index]
                                ?.description_text_color || "#000000"
                            }
                            // error={
                            //   screenTouched?.description_text_color
                            //     ? screenErrors?.description_text_color
                            //     : ""
                            // }
                            label={"Description Text Color"}
                            classes={"col-md-6"}
                            handleBlur={handleBlur}
                            inputType={"color"}
                            handleChange={handleChange}
                          />
                        </>
                      )}
                      {index > 0 ? (
                        <button
                          type="button"
                          className="btn me-2 btn-primary"
                          onClick={() => remove(index)}
                        >
                          Remove
                        </button>
                      ) : null}
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn me-2 btn-primary"
                  onClick={() =>
                    push({
                      title: "",
                      subtitle: "",
                      image: "",
                      buttontext: "",
                      load_fullscreen: false,
                    })
                  }
                >
                  + Add
                </button>
              </div>
            )}
          </FieldArray>

          <div className="float-end">
            <button
              type="submit"
              className="btn me-2 btn-primary"
              disabled={isSubmitting}
            >
              Save
            </button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default OnBoardingForm;
